<template>
  <div class="faq-bloc">
    <div class="faq-bloc-header">
      <h2>{{$resx('FaqAnimalsInformationsText')}}</h2>
    </div>
    <div v-if="!isSaving" class="faq-bloc-body">
      <div class="row">
        <div class="col col-16">
          {{$resx('FaqDogsAllowedText')}}
        </div>
        <div class="col col-16">
          <span v-if="!editMode && modelCopy.dogsAllowed===null">?</span>
          <span v-if="!editMode && modelCopy.dogsAllowed!==null">{{getAcceptance(modelCopy.dogsAllowed)}}</span>
          <select v-if="editMode" v-model="modelCopy.dogsAllowed">
            <option :value="null" disabled>?</option>
            <option :value="0">{{getAcceptance(0)}}</option>
            <option :value="1">{{getAcceptance(1)}}</option>
            <option :value="2">{{getAcceptance(2)}}</option>
            <option :value="3">{{getAcceptance(3)}}</option>
          </select>
        </div>
        <div class="col col-16" v-if="dogsAllowed">
          {{$resx('FaqDogsCat12AllowedText')}}
        </div>
        <div class="col col-16" v-if="dogsAllowed">
          <span v-if="!editMode && modelCopy.dogsCat12Allowed===null">?</span>
          <i v-if="!editMode && modelCopy.dogsCat12Allowed!==null" class='material-icons'>{{getCheckStateClass(modelCopy.dogsCat12Allowed)}}</i>
          <select v-if="editMode" v-model="modelCopy.dogsCat12Allowed">
            <option :value="false">{{$resx('NoText')}}</option>
            <option :value="true">{{$resx('YesText')}}</option>
          </select>
        </div>
        <div class="col col-16" v-if="dogsAllowed">{{$resx('FaqDogsMaxWeightAllowedText')}}</div>
        <div class="col col-16" v-if="dogsAllowed">
          <span v-if="!editMode && modelCopy.dogsMaxWeight===null">?</span>
          <span v-if="!editMode && modelCopy.dogsMaxWeight!==null">{{modelCopy.dogsMaxWeight}}</span>
          <input v-if="editMode" type="number" v-model.number="modelCopy.dogsMaxWeight" min="10" max="50" name="dogsMaxWeight" v-validate="'between:10,50'" :class="{'field-validation-error': errors.has('dogsMaxWeight')}" />
        </div>
      </div>
      <div class="row">
        <div class="col col-16">{{$resx('FaqCatsAllowedText')}}</div>
        <div class="col col-16">
          <span v-if="!editMode && modelCopy.catsAllowed===null">?</span>
          <span v-if="!editMode && modelCopy.catsAllowed!==null">{{getAcceptance(modelCopy.catsAllowed)}}</span>
          <select v-if="editMode" v-model="modelCopy.catsAllowed">
            <option :value="null" disabled>?</option>
            <option :value="0">{{getAcceptance(0)}}</option>
            <option :value="1">{{getAcceptance(1)}}</option>
            <option :value="2">{{getAcceptance(2)}}</option>
            <option :value="3">{{getAcceptance(3)}}</option>
          </select>
        </div>
      </div>
      <div class="row">
          <div class="col col-16">{{$resx('FaqNacsAllowedText')}}</div>
          <div class="col col-16">
            <span v-if="!editMode && modelCopy.nacsAllowed===null">?</span>
            <span v-if="!editMode && modelCopy.nacsAllowed!==null">{{getAcceptance(modelCopy.nacsAllowed)}}</span>
            <select v-if="editMode" v-model="modelCopy.nacsAllowed">
              <option :value="null" disabled>?</option>
              <option :value="0">{{getAcceptance(0)}}</option>
              <option :value="1">{{getAcceptance(1)}}</option>
              <option :value="2">{{getAcceptance(2)}}</option>
              <option :value="3">{{getAcceptance(3)}}</option>
            </select>
          </div>
        </div>
    </div>
    <div v-else class="faq-bloc-body text-center">
      <i class="loading material-icons">cached</i>
    </div>
    <div class="faq-bloc-footer">
      <button v-show="!editMode" class="btn btn-secondary" @click="editMode=true">{{$resx('EditText')}}</button>
      <button v-show="editMode" class="btn btn-secondary" @click="editMode=false">{{$resx('CancelText')}}</button>
      <button v-show="editMode" style="margin-left:.5em" class="btn btn-primary" @click="save" :disabled="isSaving">{{$resx('SaveText')}}</button>
    </div>
  </div>
</template>
<script>
import faqServices from '../../services/faqServices'

export default {
  props: {
    animals: null
  },
  data () {
    return {
      isSaving: false,
      editMode: false,
      modelCopy: null
    }
  },
  computed: {
    // camping actuellement sélectionné
    currentCampingId () {
      return this.$store.getters['partner/currentCampingId']
    },
    // retourne si les chiens sont acceptés
    dogsAllowed () {
      if (this.modelCopy !== null) {
        return this.modelCopy.dogsAllowed !== null && (this.modelCopy.dogsAllowed > 0)
      }
      return false
    }
  },
  watch: {
    editMode: function (val) {
      this.modelCopy = this.copyFullObject(this.animals)
    },
    dogsAllowed: function () {
      if (!this.dogsAllowed) {
        this.modelCopy.dogsCat12Allowed = false
      }
    }
  },
  methods:
  {
    // Copie de l'objet référence dans une autre variable
    copyFullObject: function (source) {
      var newObj = Object.assign({}, source)
      return newObj
    },

    // retourne le texte selon l'acceptation de tel ou tel animal
    getAcceptance: function (item) {
      switch (item) {
        case 0:
          return this.$resx('NoText')
        case 1:
          return this.$resx('RentalText')
        case 2:
          return this.$resx('PitchText')
        case 3:
          return this.$resx('EveryWhereText')
      }
    },

    // retourne l'icone pour indiquer le statut d'un item
    getCheckStateClass: function (value) {
      if (value === null) {
        return 'fa-question'
      } else {
        return value ? 'check' : 'close'
      }
    },

    // sauvegarde des infos
    save: function () {
      const self = this
      self.isSaving = true
      faqServices.saveFaqAnimals(this.currentCampingId, this.modelCopy)
        .then(response => {
          // signaler l'update au parent
          self.$emit('update-items', this.copyFullObject(this.modelCopy))
          self.isSaving = false
          self.editMode = false
          const message = self.$resx('FaqSavedText')
          self.$store.commit('app/showSnack', { type: 'success', message: message })
        })
        .catch(error => {
          self.isSaving = false
          self.$store.commit('app/showSnack', { type: 'error', message: error.response.data.message })
        })
    }
  },
  created: function () {
    // console.log('animals created')
    this.modelCopy = this.copyFullObject(this.animals)
  }
}
</script>
